import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getPartnerContactsCrud } from '../lib/getPartnerContactsCrud'
import { selectContacts } from '../selectors/selectContacts'
import { selectContactsLoading } from '../selectors/selectContactsLoading'
import { fetchContacts } from '../thunks/fetchContacts'

import { useContactsFilters } from './useContactsFilters'

interface IParams {
  /** `null` lists the contacts of every offering. */
  programType: ProgramTypes | null
  partnerId: string
}

export const usePartnerContacts = ({ programType, partnerId }: IParams) => {
  const dispatch = useDispatch()

  // Initialize filters
  const { partnerId: statePartnerId, programType: stateProgramType } = useContactsFilters({
    programType,
    partnerId,
  })

  // Select data and loading state
  const data = useSelector(selectContacts)
  const crud = useMemo(
    () => getPartnerContactsCrud({ partnerId: statePartnerId, programType: stateProgramType }),
    [statePartnerId, stateProgramType]
  )
  const isLoading = useSelector(selectContactsLoading)
  const isEveryOffering = programType === null

  // Dispatch fetch on mount/change, once the store holds the offering asked for
  useEffect(() => {
    if (statePartnerId && (isEveryOffering ? stateProgramType === null : stateProgramType)) {
      dispatch(fetchContacts())
    }

    return () => {
      crud.removeQueries()
    }
  }, [dispatch, statePartnerId, stateProgramType, crud, isEveryOffering])

  return {
    data,
    isLoading,
  }
}
